// All DateTime values from the backend are conceptually UTC. The orchestrator's
// AppDbContext now stamps Kind=Utc via a value converter so JSON output always carries
// the trailing Z — but a defensive parser here protects against any path that might
// leak a non-Z timestamp (third-party APIs, future endpoints, manual JSON edits to
// SpecJson, etc.). Browsers parse "2026-05-06T13:00:00" as LOCAL time, which would
// shift chart markers by the user's TZ offset. Detect a missing zone designator and
// append Z so all our backend timestamps land on the same epoch.

const HAS_ZONE = /Z$|[+-]\d{2}:?\d{2}$/;

/**
 * Parse an ISO-8601 timestamp from our backend and return milliseconds since epoch (UTC).
 * If the string lacks a zone designator, treat it as UTC.
 */
export function parseBackendTimestamp(iso: string): number {
  if (!iso) return NaN;
  return Date.parse(HAS_ZONE.test(iso) ? iso : iso + "Z");
}

/** Convenience: parse to lightweight-charts UNIX seconds. */
export function toChartTime(iso: string): number {
  return parseBackendTimestamp(iso) / 1000;
}
